import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { catchError, Observable, of, switchMap, take } from 'rxjs'
import { AdminPanelService } from '../service/admin/admin-panel.service'
import { DdcLoggerService } from '../service/log/ddc-logger.service'
import { UserService } from '../service/user-info/user.service'

@Injectable({
  providedIn: 'root',
})
export class AuthAdminGuard implements CanActivate {
  constructor(
    private logger: DdcLoggerService,
    private adminPanelService: AdminPanelService,
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    this.logger.info('AuthAdminGuard: canActivate()')

    return this.userService.userInfo$.pipe(
      take(1),
      switchMap((userInfo: any): Observable<boolean> => {
        if (!userInfo) {
          this.logger.warn('AuthAdminGuard: No user info available')
          this.router.navigate(['/login'])
          return of(false)
        }

        // Check if user is admin and verified
        if (!userInfo.is_admin || !userInfo.is_verified) {
          this.logger.warn('AuthAdminGuard: User is not admin or not verified')
          this.router.navigate(['/no_access'])
          return of(false)
        }

        // Check if admin has a valid session
        if (this.adminPanelService.isAdminAuthenticated()) {
          this.logger.info('AuthAdminGuard: Admin access granted - valid session exists')
          return of(true)
        }

        // If no valid admin session, redirect to login but allow component to handle 6-digit verification
        this.logger.info(
          'AuthAdminGuard: Admin user but no valid session - allowing access for verification',
        )
        return of(true)
      }),
      catchError(error => {
        this.logger.error('AuthAdminGuard: Error occurred', error)
        this.router.navigate(['/login'])
        return of(false)
      }),
    )
  }
}
